/*
PM 2021-07-29
KONCEPCJA KOMPONENTU
================

Komponent mapy

================

Kontener mapy to komponent MapContainer (zaimportowany z biblioteki react-leaflet)
Propsy komponentu MapContainer:
* center - wspolrzedne srodka mapy, tylko do inicjacji, brane z propsa obszar (od komponentu rodzica MapContainer)

Wybor warstwy (stylu) mapy to komponent LayersControl (zaimportowany z biblioteki react-leaflet)
Warstwy do wyboru to komponenty LayersControl.BaseLayer
Props checked mowi, ktora warstwa jest wyswietlana domyslnie
Warstwy sa renderowane przez komponenty TileLayer (zaimportowany z biblioteki react-leaflet)
Mozna je nakladac na siebie

Na mapie sa renderowane obiekty noclegowe jako pineski - komponenty Marker (zaimportowany z biblioteki react-leaflet)
Komponent Tooltip to dymek pojawiajacy sie po najechaniu na pineske (zaimportowany z biblioteki react-leaflet)
Style markerow brane z propsa - funkcji getIcon (od komponentu rodzica MapContainer)

================
importowane komponenty:

*/

import * as React from 'react';

import {
    MapContainer, TileLayer, Marker, Tooltip, LayersControl,
    ZoomControl, ScaleControl
} from 'react-leaflet';

import 'leaflet/dist/leaflet.css';

import L, { TileErrorEvent, LayersControlEvent } from 'leaflet';

import { connect } from 'react-redux';

import { AppState } from '../../appredux';
import { tiles } from './mapData';
import { Info } from '../../api';

//PM 2021-11-30
//wstrzykniecie tylko uzywanych pol z magazynu danych
interface MapProps {
    contact: Info,
    mapaGps: string,
    getIcon: (color: number) => L.Icon | undefined, //pobieranie koloru pineski
    lat: number,                                    //szer. geogr.
    lng: number,                                    //dl. geogr.
    bounds: L.LatLngBoundsExpression,               //początkowe granice mapy
    tooltip: string,                                //opis przy pinesce
    tileErrors: string[],
    tileName: string,
    addTileError: (aName: string) => Promise<void>
    setTileName: (aName: string) => Promise<void>
}

class Map extends React.Component<MapProps, any>  {

    //PM 2021-11-04 zrezygnowano
    // mapPlaceholder = () => {
    //     const { classes } = this.props

    //     return (
    //         <div className={classes.frame} style={{ width: '100%', height: '100%' }}>
    //             <span className={classes.helper}></span>
    //             <img
    //                 className={classes.img}
    //                 style={{ maxWidth: '1000px', width: window.innerWidth > 600 ? '' : (window.innerWidth - 30) + 'px' }}
    //                 src="img/map-placeholder.jpg"
    //                 alt="Brak mapy"
    //             />
    //         </div>
    //     )
    // }

    //PM 2021-10-19
    baseLayerChange = async (event: LayersControlEvent) => {
        await this.props.setTileName(event.name)
    }

    //raz przy tworzeniu mapy
    //PM 2021-10-19
    whenCreated = async (map: L.Map) => {
        map.on('baselayerchange', this.baseLayerChange);
    }

    //PM 2021-11-30
    tooltip = () => {
        const wspolrzedne = this.props.mapaGps.split(' ');

        if (wspolrzedne.length === 2)
            return (
                <React.Fragment>
                    {this.props.tooltip}
                    <br />
                    {this.props.mapaGps}
                </React.Fragment>
            )
        else
            return (
                <React.Fragment>
                    Wawel
                    <br />
                    {`${this.props.lat}N ${this.props.lng}E`}
                </React.Fragment>
            )
    }

    //główna pętla
    //PM 2021-11-30
    //obsługa braku wspolrzednych do mapy
    render = () => {

        return (
            <MapContainer
                bounds={this.props.bounds}
                zoomSnap={0.1} zoomDelta={0.5}
                style={{ height: (window.innerHeight - 29) + 'px', maxHeight: window.innerWidth > 600 ? '' : window.innerWidth + 'px' }}
                zoomControl={false}
                whenCreated={this.whenCreated}
            >
                <LayersControl >
                    {tiles.filter(tile => !this.props.tileErrors.includes(tile.name)).map((tile, index) => {
                        return (
                            <LayersControl.BaseLayer key={tile.name} checked={this.props.tileErrors.length && index === 0 ? true : tile.checked} name={tile.name}>
                                {/* {<React.Fragment> */}
                                <TileLayer
                                    attribution={tile.attribution}
                                    url={tile.url}
                                    eventHandlers={{
                                        tileerror: async (event: TileErrorEvent) => {
                                            if (!this.props.tileErrors.includes(tile.name))
                                                await this.props.addTileError(tile.name)
                                        }
                                    }}
                                />
                                {/* {this.props.tileErrors.includes(tile.name) ?
                                        this.mapPlaceholder() : null}
                                </React.Fragment>} */}
                            </LayersControl.BaseLayer>
                        )
                    })}
                    {/* <LayersControl.BaseLayer name="Voyager Znaczniki">
                        <LayerGroup>
                            <TileLayer
                                attribution='&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>, &copy; <a href="https://carto.com/attributions">CARTO</a>'
                                url="https://{s}.basemaps.cartocdn.com/rastertiles/voyager_nolabels/{z}/{x}/{y}.png"
                            />
                            <TileLayer
                                attribution='&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>, &copy; <a href="https://carto.com/attributions">CARTO</a>'
                                url="https://{s}.basemaps.cartocdn.com/rastertiles/voyager_only_labels/{z}/{x}/{y}.png"
                            />
                        </LayerGroup>
                    </LayersControl.BaseLayer>
                    <LayersControl.BaseLayer name="Dark Znaczniki">
                        <LayerGroup>
                            <TileLayer
                                attribution='&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>, &copy; <a href="https://carto.com/attributions">CARTO</a>'
                                url="https://{s}.basemaps.cartocdn.com/rastertiles/dark_nolabels/{z}/{x}/{y}.png"
                            />
                            <TileLayer
                                attribution='&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>, &copy; <a href="https://carto.com/attributions">CARTO</a>'
                                url="https://{s}.basemaps.cartocdn.com/rastertiles/light_only_labels/{z}/{x}/{y}.png"
                            />
                        </LayerGroup>
                    </LayersControl.BaseLayer>
                    <LayersControl.BaseLayer name="Voyager bez znaczników">
                        <TileLayer
                            attribution='&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>, &copy; <a href="https://carto.com/attributions">CARTO</a>'
                            url="https://{s}.basemaps.cartocdn.com/rastertiles/voyager_nolabels/{z}/{x}/{y}.png"
                        />
                    </LayersControl.BaseLayer>
                    <LayersControl.BaseLayer name="Dark bez znaczników">
                        <TileLayer
                            attribution='&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>, &copy; <a href="https://carto.com/attributions">CARTO</a>'
                            url="https://{s}.basemaps.cartocdn.com/rastertiles/dark_nolabels/{z}/{x}/{y}.png"
                        />
                    </LayersControl.BaseLayer> */}
                </LayersControl>
                {this.props.tileErrors.includes(this.props.tileName) ?
                    null
                    :
                    (
                        <React.Fragment>
                            <ZoomControl position="topright" />
                            <ScaleControl position="bottomleft" />
                            <Marker
                                position={[this.props.lat, this.props.lng]}
                                icon={this.props.getIcon(1)}
                            >
                                <Tooltip>
                                    {this.tooltip()}
                                </Tooltip>
                            </Marker>
                        </React.Fragment>
                    )}
            </MapContainer>
        );
    }
}

// const styles = (theme: Theme) => ({
//     frame: {
//         whiteSpace: 'nowrap' as 'nowrap', /* This is required unless you put the helper span closely near the img */
//         textAlign: 'center' as 'center',
//     },
//     helper: {
//         display: 'inline-block',
//         height: '100%',
//         verticalAlign: 'middle'
//     },
//     img: {
//         verticalAlign: 'middle',
//         maxHeight: '447px',
//         maxWidth: '1000px'
//     }
// });

const mapStateToProps = (state: AppState) => ({
    contact: state.pageState.contact,
    mapaGps: state.pageState.mapaGps
});

export default connect(mapStateToProps)(Map);